import React from "react";
import {DropdownButton, FormGroup, MenuItem, Pagination} from "react-bootstrap";

class PaginationComponent extends React.Component {

  constructor(props) {
    super(props);
    this.state = {size: 10, page: props.currentPage};
  }

  componentWillReceiveProps(nextProps) {
    const {page, size} = this.state;
    if (page !== nextProps.currentPage || size !== nextProps.size) {
      this.setState({size: nextProps.size, page: nextProps.currentPage});
    }
  }

  setPage(page, onChange) {
    this.setState({...this.state, page});
    onChange({...this.state, page});
  }

  setItemsPerPage(itemsPerPage, onChange) {
    this.setState({...this.state, page: 0, size: itemsPerPage});
    onChange(this.state);
  }

  render() {
    const {totalPages, onChange} = this.props;
    const {page, size = 10} = this.state;
    console.log('current page: ', this.state)
    let items = [];
    for (let number = 1; number <= totalPages; number++) {
      const pageNumber = number - 1;
      items.push(
          <Pagination.Item onClick={() => this.setPage(pageNumber, onChange)} key={number} active={number === (page + 1)}>{number}</Pagination.Item>
      );
    }

    return (
        <div className="ByondPagination">
          <div className="pagination-flex">
            <div key='paging-left' className="col-md-6 itemsPerPage">
              <FormGroup>
                <DropdownButton title={`${size} items por página`}
                                id="bg-nested-dropdown"
                                onSelect={(e) => this.setItemsPerPage(e, onChange)}>
                  <MenuItem eventKey="5">5</MenuItem>
                  <MenuItem eventKey="10">10</MenuItem>
                  <MenuItem eventKey="25">25</MenuItem>
                  <MenuItem eventKey="50">50</MenuItem>
                  <MenuItem eventKey="100">100</MenuItem>
                </DropdownButton>
              </FormGroup>
            </div>
            {totalPages ?
                <div key="paging-right" className="col-md-6 text-right">
                  <Pagination bsSize="small">
                    <Pagination.First onClick={() => this.setPage(0, onChange)}/>
                    <Pagination.Prev onClick={() => this.setPage((page - 1), onChange)}/>
                    {items}
                    <Pagination.Next disabled={page === totalPages} onClick={() => totalPages > page && this.setPage((page + 1), onChange)}/>
                    <Pagination.Last disabled={page === totalPages} onClick={() => totalPages > page && this.setPage(totalPages, onChange)}/>
                  </Pagination>
                </div>
                : ''}
          </div>
        </div>
    );
  };
}

export default PaginationComponent;



// WEBPACK FOOTER //
// ./src/component/Table/PaginationComponent.js